import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Watch from "@/pages/Watch";

const MOBILE_PORTRAIT_QUERY = "(orientation: portrait) and (pointer: coarse)";

export default function App() {
  const [requiresLandscape, setRequiresLandscape] = useState(() =>
    window.matchMedia(MOBILE_PORTRAIT_QUERY).matches
  );

  useEffect(() => {
    const media = window.matchMedia(MOBILE_PORTRAIT_QUERY);
    const updateOrientation = () => setRequiresLandscape(media.matches);
    updateOrientation();
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", updateOrientation);
      return () => media.removeEventListener("change", updateOrientation);
    }
    media.addListener(updateOrientation);
    return () => media.removeListener(updateOrientation);
  }, []);

  return (
    <BrowserRouter>
      {requiresLandscape ? (
        <main className="landscape-gate" role="alert" aria-live="assertive">
          <div className="landscape-gate__phone" aria-hidden="true">
            <span>↻</span>
          </div>
          <div className="vfd text-xl">请开启横屏</div>
          <p>旋转手机后将自动继续</p>
          <span className="landscape-gate__hint">LANDSCAPE REQUIRED</span>
        </main>
      ) : (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/watch" element={<Watch />} />
        </Routes>
      )}
    </BrowserRouter>
  );
}
